// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8ffd554e","488":"112f5f0f","732":"88ba9028","977":"0ab1f3e5"}[chunkId] + ".chunk.js";
};